import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "../services/auth.service";
import {GuardService} from "../services/guard.service";

@Injectable({
  providedIn: 'root'
})
export class WelcomeGuard  {
  constructor(private guard: GuardService, private auth: AuthService, private router: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.guard.startDeciding()

    if (this.auth.hasValidCsrfToken()) {
       this.guard.finishDeciding()
      return this.router.createUrlTree(['editor'])
    }

    this.guard.finishDeciding()
    return true;
  }

}
